import { Libraries, useJsApiLoader } from '@react-google-maps/api';

export function useGoogleMapsScript(apiKey: string, libraries: Libraries) {
  const { isLoaded: scriptLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: apiKey,
    libraries: libraries
  });

  return { scriptLoaded, loadError };
}
